import * as types from "./ActionsNotificationReducer";

export default function notificationReducer(
    state = {
        notification: {
            className: "",
            show: false,
            text: ""
        }
    }, action: any) {
    switch (action.type) {
        case types.SHOW_NOTIFICATION:
            state.notification = {
                className: action.className,
                show: true,
                text: action.text
            };
            break;
        case types.HIDE_NOTIFICATION:
            state.notification = state.notification = {
                className: state.notification.className,
                show: false,
                text: ""
            };
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/stores/reducers/notification/NotificationReducer.ts